@switch (type()) {
  @case ('icon') {
    <button mat-icon-button class="icon-button" [disabled]="disabled() || loading()">
      @if (loading()) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon fontSet="material-icons-outlined">{{ matIcon() }}</mat-icon>
      }
    </button>
  }
  @case ('flat') {
    <button mat-flat-button class="button mat-primary" [disabled]="disabled() || loading()">
      @if (loading()) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        @if (iconPosition() === 'end') {
          <mat-icon fontSet="material-icons-outlined" iconPositionEnd>{{ matIcon() }}</mat-icon>
        } @else {
          <mat-icon fontSet="material-icons-outlined">{{ matIcon() }}</mat-icon>
        }
        {{ label() }}
      }
    </button>
  }
  @default {
    <button mat-flat-button class="button mat-primary" [disabled]="disabled() || loading()">
      @if (loading()) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        @if (iconPosition() === 'end') {
          <mat-icon fontSet="material-icons-outlined" iconPositionEnd>{{ matIcon() }}</mat-icon>
        } @else {
          <mat-icon fontSet="material-icons-outlined">{{ matIcon() }}</mat-icon>
        }
        {{ label() }}
      }
    </button>
  }
}
